import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { cities } from '../../models/cities';
import { countries } from '../../models/countries';
import { Circle } from '../../models/courts/circle';
import { CourtsApiService } from 'src/app/core/services/api/courts-api.service';
import { NgSelectProps } from '../../models/ng-select-props';

@Component({
  selector: 'app-circle-create-edit',
  templateUrl: './circle-create-edit.component.html',
  styleUrls: ['./circle-create-edit.component.scss']
})
export class CircleCreateEditComponent implements OnInit {
  public circle: Circle;
  public cities = cities;
  public countries = countries;
  public courtNgSelect = null;
  public cityNgSelect = null;

  @ViewChild('circlesModal') circlesModal;
  @Output() submit: EventEmitter<Circle> = new EventEmitter<Circle>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: CourtsApiService,
    private spinner: NgxSpinnerService,

  ) {
    this.courtNgSelect = new NgSelectProps(this.api.getCourts);
    this.cityNgSelect = new NgSelectProps(this.api.getCities);
  }

  ngOnInit(): void {
    this.courtNgSelect.loadItems();
  }

  // handle the popup
  open(circle: Circle) {
    this.circle = Object.assign(new Circle(), circle);
    this.modalRef = this.modalService.open(this.circlesModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    this.circle.courtId = this.circle.court.id;
    this.circle.cityId = this.circle.city.id;
    if (this.circle.id) {
      this.spinner.show();
      this.api.updateCircle(this.circle).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createCircle(this.circle).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

  searchFn() {
    return true;
  }


}


